module.exports = __webpack_public_path__ + "img/jcb.fd8a3a22.svg";